export let config = {
	intro: {
		preline: {
			en: "",
			de: "",
		},
		headline: {
			en: "Find an academy near you",
			de: "Find an academy near you",
		},
		description: {
			en: "",
			de: "",
		},
	},
	finderDefaultImage:
		"/apps/configurators/academy/assets/images/worldmap.svg.html",
	finderDefaultText: {
		en: "Academies",
		de: "Akademien",
	},
	continents: [
		{
			id: 1001,
			type: "continent",
			text: {
				en: "Americas",
				de: "Amerika",
			},
			image: "/apps/configurators/academy/assets/images/america-map.svg",
			svgId: "america",
		},
		{
			id: 1002,
			type: "continent",
			text: {
				en: "Europe",
				de: "Europa",
			},
			image: "/apps/configurators/academy/assets/images/europe-map.svg",
			svgId: "europe",
		},
		{
			id: 1003,
			type: "continent",
			text: {
				en: "Asia-Pacific",
				de: "Asien",
			},
			image: "/apps/configurators/academy/assets/images/apec-map.svg",
			svgId: "apec",
		},
		{
			id: 1004,
			type: "continent",
			text: {
				en: "MEA",
				de: "MEA",
			},
			image: "/apps/configurators/academy/assets/images/mea-map.svg",
			svgId: "mea",
		},
	],
	countries: [
		{
			id: 2001,
			type: "country",
			text: {
				en: "USA",
				de: "USA",
			},
			continentId: 1001,
		},
		{
			id: 2002,
			type: "country",
			text: {
				en: "China",
				de: "China",
			},
			continentId: 1003,
		},
		{
			id: 2003,
			type: "country",
			text: {
				en: "Germany",
			},
			continentId: 1002,
		},
		{
			id: 2004,
			type: "country",
			text: {
				en: "Denmark",
			},
			continentId: 1002,
		},
		{
			id: 2006,
			type: "country",
			text: {
				en: "France",
			},
			continentId: 1002,
		},
		{
			id: 2007,
			type: "country",
			text: {
				en: "Greece",
			},
			continentId: 1002,
		},
		{
			id: 2008,
			type: "country",
			text: {
				en: "Switzerland",
			},
			continentId: 1002,
		},
		{
			id: 2009,
			type: "country",
			text: {
				en: "South Korea",
			},
			continentId: 1003,
		},
		{
			id: 2010,
			type: "country",
			text: {
				en: "India",
			},
			continentId: 1003,
		},
		{
			id: 2011,
			type: "country",
			text: {
				en: "Philippines",
			},
			continentId: 1003,
		},
		{
			id: 2012,
			type: "country",
			text: {
				en: "Singapore",
			},
			continentId: 1003,
		},
		{
			id: 2013,
			type: "country",
			text: {
				en: "Brazil",
			},
			continentId: 1001,
		},
		{
			id: 2014,
			type: "country",
			text: {
				en: "UAE",
			},
			continentId: 1004,
			disabled: false,
		},
	],
	locations: [
		{
			id: 1,
			type: "location",
			title: {
				en: "Fort Lauderdale",
			},
			categoryIds: [2, 3],
			city: "Fort Lauderdale",
			address: {
				line1: "Everllence USA Inc.",
				line2: "PrimeServ Academy Fort Lauderdale",
				line3: "1491 SW 5th Court, Building 1501, ",
				line4: "Pompano Beach, FL 33069, USA",
			},
			contact: {
				phone: {
					en: "+1 954 960 6700",
				},
				fax: {
					en: "+1 954 782 5426",
				},
				mail: {
					en: "primeserv.academy-fll@everllence.com",
				},
			},
			links: [
				{
					text: {
						en: "Explore courses",
					},
					mode: "fill",
					url: "https://sem.everllence.com/sem/#CallID=SeminarsByLocation;Fort%20Lauderdale",
					type: "",
				},
			],
			countryId: 2001,
			continentId: 1001,
			svgPinId: "usa-fortlauderdale",
			icon: "/apps/configurators/academy/assets/images/flag-usa.svg",
		},
		{
			id: 2,
			type: "location",
			title: {
				en: "Augsburg",
			},
			categoryIds: [2, 3, 4],
			city: "Augsburg",
			address: {
				line1: "Everllence SE",
				line2: "PrimeServ Academy Augsburg",
				line3: "Stadtbachstr. 1",
				line4: "86153 Augsburg, Germany",
			},
			contact: {
				phone: {
					en: "+49-821-322-1397",
				},
				mail: {
					en: "primeserv.academy-aug@everllence.com",
				},
			},
			links: [
				{
					text: {
						en: "Explore courses",
					},
					mode: "fill",
					url: "https://sem.everllence.com/sem/#CallID=SeminarsByLocation;Augsburg",
					type: "",
				},
			],
			countryId: 2003,
			continentId: 1002,
			svgPinId: "de-augsburg",
			icon: "/apps/configurators/academy/assets/images/flag-germany.svg",
		},
		{
			id: 3,
			type: "location",
			title: {
				en: "Oberhausen",
			},
			categoryIds: [5],
			circlescity: "Oberhausen",
			address: {
				line1: "Everllence SE",
				line2: "PrimeServ Academy Oberhausen",
				line3: "Steinbrinkstraße 1 ",
				line4: "46145 Oberhausen, Germany",
			},
			contact: {
				phone: {
					en: "+49 208 692-9166 ",
				},
				mail: {
					en: "primeserv.academy-obh@everllence.com",
				},
			},
			links: [
				{
					text: {
						en: "Explore courses",
					},
					mode: "fill",
					url: "https://sem.everllence.com/sem/#CallID=SeminarsByLocation;Oberhausen",
					type: "",
				},
			],
			countryId: 2003,
			continentId: 1002,
			svgPinId: "de-oberhausen",
			icon: "/apps/configurators/academy/assets/images/flag-germany.svg",
		},
		{
			id: 4,
			type: "location",
			title: {
				en: "Copenhagen",
			},
			categoryIds: [1],
			city: "Copenhagen",
			address: {
				line1: "Everllence, filial af Everllence SE, Tyskland",
				line2: "PrimeServ Academy Copenhagen",
				line3: "Teglholmsgade 35",
				line4: "2450 Copenhagen SV, Denmark",
			},
			contact: {
				phone: {
					en: "+45 33 85 22 27",
				},
				mail: {
					en: "primeserv.academy-cph@everllence.com",
				},
			},
			links: [
				{
					text: {
						en: "Explore courses",
					},
					mode: "fill",
					url: "https://sem.everllence.com/sem/#CallID=SeminarsByLocation;Copenhagen",
					type: "",
				},
			],
			countryId: 2004,
			continentId: 1002,
			svgPinId: "dk-copenhagen",
			icon: "/apps/configurators/academy/assets/images/flag-denmark.svg",
		},
		{
			id: 5,
			type: "location",
			title: {
				en: "Holeby",
			},
			categoryIds: [2],
			city: "Holeby",
			address: {
				line1: "Everllence, filial af Everllence SE, Tyskland",
				line2: "PrimeServ Academy Holeby",
				line3: "H. Christoffersensvej 6",
				line4: "4960 Holeby, Denmark",
			},
			contact: {
				phone: {
					en: "+45 5469 3100",
				},
				mail: {
					en: "primeserv.academy-4stroke-dk@everllence.com",
				},
			},
			links: [
				{
					text: {
						en: "Explore courses",
					},
					mode: "fill",
					url: "https://sem.everllence.com/sem/#CallID=SeminarsByLocation;Holeby",
					type: "",
				},
			],
			countryId: 2004,
			continentId: 1002,
			svgPinId: "dk-holeby",
			icon: "/apps/configurators/academy/assets/images/flag-denmark.svg",
		},
		{
			id: 6,
			type: "location",
			title: {
				en: "Frederikshavn",
			},
			categoryIds: [2],
			city: "Frederikshavn",
			address: {
				line1: "Everllence, filial af Everllence SE, Tyskland",
				line2: "PrimeServ Academy Frederikshavn",
				line3: "Langerak 74",
				line4: "9900 Frederikshavn, Denmark",
			},
			contact: {
				phone: {
					en: "+45 96 204100",
				},
				mail: {
					en: "primeserv.academy-4stroke-dk@everllence.com",
				},
			},
			links: [
				{
					text: {
						en: "Explore courses",
					},
					mode: "fill",
					url: "https://sem.everllence.com/sem/#CallID=SeminarsByLocation;Frederikshavn",
					type: "",
				},
			],
			countryId: 2004,
			continentId: 1002,
			svgPinId: "dk-frederikshavn",
			icon: "/apps/configurators/academy/assets/images/flag-denmark.svg",
		},
		{
			id: 8,
			type: "location",
			title: {
				en: "Saint-Nazaire",
			},
			categoryIds: [2, 4],
			city: "Saint-Nazaire",
			address: {
				line1: "Everllence France SAS",
				line2: "PrimeServ Academy Saint-Nazaire",
				line3: "Avenue Antoine Bourdelle 8, BP 427",
				line4: "44615 Saint-Nazaire Cedex France",
			},
			contact: {
				phone: {
					en: "+33 24090 6515",
				},
				mail: {
					en: "primeserv.academy-stn@everllence.com",
				},
			},
			links: [
				{
					text: {
						en: "Explore courses",
					},
					mode: "fill",
					url: "https://sem.everllence.com/sem/#CallID=SeminarsByLocation;Saint-Nazaire",
					type: "",
				},
				{
					text: {
						en: "St. Nazaire Academy page",
					},
					mode: "fill",
					url: "https://www.everllence.com/services/primeserv-academy/locations/primeserv-academy-saint-nazaire",
					type: "",
				},
			],
			countryId: 2006,
			continentId: 1002,
			svgPinId: "fr-saintnazaire",
			icon: "/apps/configurators/academy/assets/images/flag-france.svg",
		},

		{
			id: 9,
			type: "location",
			title: {
				en: "Piraeus",
			},
			categoryIds: [1, 3],
			city: "Piraeus",
			address: {
				line1: "Everllence Hellas Ltd ",
				line2: "PrimeServ Academy Piraeus",
				line3: "Akti Miaouli 89",
				line4: "Piraeus 185 38, Greece",
			},
			contact: {
				phone: {
					en: "+30 21 0458 7900",
				},
				mail: {
					en: "primeserv.academy-pir@everllence.com",
				},
			},
			links: [
				{
					text: {
						en: "Explore courses",
					},
					mode: "fill",
					url: "https://sem.everllence.com/sem/#CallID=SeminarsByLocation;Piraeus",
					type: "",
				},
			],
			countryId: 2007,
			continentId: 1002,
			svgPinId: "gr-piraeus",
			icon: "/apps/configurators/academy/assets/images/flag-greece.svg",
		},

		{
			id: 10,
			type: "location",
			title: {
				en: "Zurich",
			},
			categoryIds: [5],
			city: "Zurich",
			address: {
				line1: "Everllence Schweiz AG",
				line2: "PrimeServ Academy Zurich",
				line3: "Hardstrasse 319",
				line4: "8005 Zurich, Switzerland",
			},
			contact: {
				mail: {
					en: "primeserv-academy-zurich@everllence.com",
				},
			},
			links: [
				{
					text: {
						en: "Explore courses",
					},
					mode: "fill",
					url: "https://sem.everllence.com/sem/#CallID=SeminarsByLocation;Zurich",
					type: "",
				},
			],
			countryId: 2008,
			continentId: 1002,
			svgPinId: "ch-zurich",
			icon: "/apps/configurators/academy/assets/images/flag-switzerland.svg",
		},
		{
			id: 11,
			type: "location",
			title: {
				en: "Shanghai",
			},
			categoryIds: [1, 2, 3],
			city: "Shanghai",
			address: {
				line1: "Everllence Shanghai Co., Ltd.",
				line2: "PrimeServ Academy Shanghai",
				line3:
					"Zhao Lou Road 3576 , Floor 1, Keji Building 1, No. Pujiang Town, Minhang District,",
				line4: "201112 Shanghai, China",
			},
			contact: {
				phone: {
					en: "+86 21 5221 2377",
				},
				mail: {
					en: "primeserv.academy-sha@everllence.com",
				},
			},
			links: [
				{
					text: {
						en: "Explore courses",
					},
					mode: "fill",
					url: "https://sem.everllence.com/sem/#CallID=SeminarsByLocation;Shanghai",
					type: "",
				},
			],
			countryId: 2002,
			continentId: 1003,
			svgPinId: "cn-shanghai",
			icon: "/apps/configurators/academy/assets/images/flag-china.svg",
		},
		{
			id: 12,
			type: "location",
			title: {
				en: "Busan",
			},
			categoryIds: [1],
			city: "Busan",
			address: {
				line1: "Everllence Korea Ltd.",
				line2: "PrimeServ Academy Busan",
				line3: "Beombang 2-ro 51",
				line4: "46727 Gangseo-gu, Busan, Korea",
			},
			contact: {
				phone: {
					en: "+82 51 440 0189",
				},
				mail: {
					en: "primeserv.academy-bus@everllence.com",
				},
			},
			links: [
				{
					text: {
						en: "Explore courses",
					},
					mode: "fill",
					url: "https://sem.everllence.com/sem/#CallID=SeminarsByLocation;Busan",
					type: "",
				},
			],
			countryId: 2009,
			continentId: 1003,
			svgPinId: "kr-busan",
			icon: "/apps/configurators/academy/assets/images/flag-southkorea.svg",
		},
		{
			id: 13,
			type: "location",
			title: {
				en: "India Mumbai",
			},
			categoryIds: [1, 6],
			city: "Mumbai",
			address: {
				line1: "Anglo Eastern Maritime Training Centre",
				line2: "Marol, Andheri-Kurla Road, Andheri (East),",
				line3: "400 059, Mumbai, India",
			},
			contact: {
				phone: {
					en: "+45 33 85 22 27",
				},
				mail: {
					en: "primeserv.academy-cph@everllence.com",
				},
			},
			links: [
				{
					text: {
						en: "Explore courses",
					},
					mode: "fill",
					url: "https://sem.everllence.com/sem/#CallID=SeminarsByLocation;Mumbai",
					type: "",
				},
			],
			countryId: 2010,
			continentId: 1003,
			svgPinId: "in-mumbai",
			icon: "/apps/configurators/academy/assets/images/flag-india.svg",
		},
		{
			id: 14,
			type: "location",
			title: {
				en: "Manila",
			},
			categoryIds: [1, 6],
			city: "Manila",
			address: {
				line1: "United Marine Training Center Inc.",
				line2: "Malate 2120, Leon Guinto Street",
				line3: "1004 Manila, The Philippines",
			},
			contact: {
				phone: {
					en: "+45 33 85 22 27",
				},
				mail: {
					en: "primeserv.academy-cph@everllence.com",
				},
			},
			links: [
				{
					text: {
						en: "Explore courses",
					},
					mode: "fill",
					url: "https://sem.everllence.com/sem/#CallID=SeminarsByLocation;Manila",
					type: "",
				},
			],
			countryId: 2011,
			continentId: 1003,
			svgPinId: "ph-manila",
			icon: "/apps/configurators/academy/assets/images/flag-philippines.svg",
		},
		{
			id: 15,
			type: "location",
			title: {
				en: "Singapore",
			},
			categoryIds: [6],
			city: "Singapore",
			address: {
				line1: "Everllence Singapore Pte. Ltd",
				line2: "PrimeServ Academy Singapore",
				line3: "29 Tuas Ave 2",
				line4: "639460 Singapore",
			},
			contact: {
				phone: {
					en: "+65 6349 1600",
				},
				mail: {
					en: "primeserv-academy-sg@everllence.com",
				},
			},
			links: [
				{
					text: {
						en: "Explore courses",
					},
					mode: "fill",
					url: "https://sem.everllence.com/sem/#CallID=SeminarsByLocation;Singapore",
					type: "",
				},
			],
			countryId: 2012,
			continentId: 1003,
			svgPinId: "sg-singpore",
			icon: "/apps/configurators/academy/assets/images/flag-singapore.svg",
		},
		{
			id: 16,
			type: "location",
			title: {
				en: "Rio de Janeiro",
			},
			categoryIds: [1, 5],
			city: "Rio de Janeiro",
			address: {
				line1: "Everllence Brasil Equipamentos e Serviços Ltda.",
				line2: "PrimeServ Academy Rio",
				line3: "Rua Carlos Gomes, 23, Bloco 1",
				line4: "CEP-24110-075 Niterói, Brazil",
			},
			contact: {
				mail: {
					en: "primeserv.academy-rio@everllence.com",
				},
			},
			links: [
				{
					text: {
						en: "Explore courses",
					},
					mode: "fill",
					url: "https://sem.everllence.com/sem/#CallID=SeminarsByLocation;Niter%C3%B3i",
					type: "",
				},
			],
			countryId: 2013,
			continentId: 1001,
			svgPinId: "br-riodejaneiro",
			icon: "/apps/configurators/academy/assets/images/flag-brazil.svg",
		},
		{
			id: 17,
			type: "location",
			title: {
				en: "Dubai",
			},
			categoryIds: [1, 2, 5],
			city: "Dubai Maritime City",
			address: {
				line1: "Everllence Middle East & Africa L.L.C",
				line2: "PrimeServ Academy Dubai",
				line3: "DMC Workshop No.159",
				line4: "P.O. Box 57091, Dubai Maritime City",
				line5: "Dubai, United Arab Emirates",
			},
			contact: {
				phone: {
					en: "+971 4 3454045",
				},
				mail: {
					en: "primeserv-academy-dubai@everllence.com",
				},
			},
			links: [
				{
					text: {
						en: "Explore courses",
					},
					mode: "fill",
					url: "https://sem.everllence.com/sem/#CallID=SeminarsByLocation;Dubai",
					type: "",
				},
			],
			countryId: 2014,
			continentId: 1004,
			svgPinId: "uae-dubai",
			icon: "/apps/configurators/academy/assets/images/flag-dubai.svg",
			disabled: false,
		},
	],
	categories: [
		{
			id: 1,
			type: "category",
			text: {
				en: "Two-stroke",
				de: "Two-stroke",
			},
			locationIds: [],
			selection: true,
			selected: true,
		},
		{
			id: 2,
			type: "category",
			text: {
				en: "Four-stroke",
				de: "Four-stroke",
			},
			locationIds: [],
			selection: true,
			selected: true,
		},
		{
			id: 3,
			type: "category",
			text: {
				en: "Turbocharger",
				de: "Turbocharger",
			},
			locationIds: [],
			selection: true,
			selected: true,
		},
		{
			id: 4,
			type: "category",
			text: {
				en: "Power Generation",
				de: "Power Generation",
			},
			locationIds: [],
			selection: true,
			selected: true,
		},
		{
			id: 5,
			type: "category",
			text: {
				en: "Industries",
				de: "Industries",
			},
			locationIds: [],
			selection: true,
			selected: true,
		},
		{
			id: 6,
			type: "category",
			text: {
				en: "Additional training venues",
				de: "Zusätzliche Schulungsorte",
				singular: {
					en: "Additional training venue",
					de: "Zusätzlicher Schulungsort",
				},
			},
			locationIds: [],
			selection: true,
			selected: true,
		},
	],
	pluses: [
		{
			id: 1,
			x: 62.4,
			y: 36,
			alternateX: 23.3,
			alternateY: 43.8,
			text: {
				en: "Fort Lauderdale",
				de: "Fort Lauderdale",
			},
			typeItemId: 1,
			relatedType: "location",
			type: "plus",
			direction: "right",
		},
		{
			id: 2,
			x: 36,
			y: 62,
			text: {
				en: "Augsburg",
				de: "Augsburg",
			},
			typeItemId: 2,
			relatedType: "location",
			type: "plus",
			direction: "right",
		},
		{
			id: 3,
			x: 31.5,
			y: 57,
			text: {
				en: "Oberhausen",
				de: "Oberhausen",
			},
			typeItemId: 3,
			relatedType: "location",
			type: "plus",
			direction: "left",
		},
		{
			id: 4,
			x: 41,
			y: 42,
			alternateX: 40,
			alternateY: 0,
			text: {
				en: "Copenhagen",
				de: "Copenhagen",
			},
			typeItemId: 4,
			relatedType: "location",
			type: "plus",
			direction: "right",
		},
		{
			id: 5,
			x: 39.2,
			y: 44.2,
			alternateX: 20,
			alternateY: 0,

			text: {
				en: "Holeby",
				de: "Holeby	",
			},
			typeItemId: 5,
			relatedType: "location",
			type: "plus",
			direction: "right",
		},
		{
			id: 6,
			x: 36,
			y: 38.5,
			alternateX: 90,
			alternateY: 0,
			text: {
				en: "Frederikshavn",
				de: "Frederikshavn",
			},
			typeItemId: 6,
			relatedType: "location",
			type: "plus",
			direction: "left",
		},
		{
			id: 7,
			x: 14,
			y: 54,
			alternateX: 42.5,
			alternateY: 28,
			text: {
				en: "Stockport",
				de: "Stockport",
			},
			typeItemId: 7,
			relatedType: "location",
			type: "plus",
			direction: "right",
		},
		{
			id: 8,
			x: 14,
			y: 70,
			alternateX: 43,
			alternateY: 35,
			text: {
				en: "Saint-Nazaire",
				de: "Saint-Nazaire",
			},
			typeItemId: 8,
			relatedType: "location",
			type: "plus",
			direction: "right",
		},
		{
			id: 7000,
			x: 63,
			y: 86,
			alternateX: 50.3,
			alternateY: 37.4,
			text: {
				en: "Piraeus",
				de: "Piraeus",
			},
			typeItemId: 9,
			relatedType: "location",
			type: "plus",
			direction: "right",
		},
		{
			id: 8000,
			x: 31.8,
			y: 64.5,
			text: {
				en: "Zurich",
				de: "Zurich",
			},
			typeItemId: 10,
			relatedType: "location",
			type: "plus",
			direction: "right",
		},
		{
			id: 9,
			x: 60.5,
			y: 46,
			alternateX: 78,
			alternateY: 44,
			text: {
				en: "Shanghai",
				de: "Shanghai",
			},
			typeItemId: 11,
			relatedType: "location",
			type: "plus",
			direction: "left",
		},
		{
			id: 10,
			x: 70.1,
			y: 34.5,
			alternateX: 80.7,
			alternateY: 39.1,
			text: {
				en: "Busan",
				de: "Busan",
			},
			typeItemId: 12,
			relatedType: "location",
			type: "plus",
			direction: "right",
		},
		{
			id: 11,
			x: 14,
			y: 65,
			alternateX: 65.2,
			alternateY: 52.5,
			text: {
				en: "India Mumbai",
				de: "India Mumbai",
			},
			typeItemId: 13,
			relatedType: "location",
			type: "plus",
			direction: "right",
		},
		{
			id: 12,
			x: 61,
			y: 65,
			alternateX: 78.3,
			alternateY: 52.5,
			text: {
				en: "Manila",
				de: "Manila",
			},
			typeItemId: 14,
			relatedType: "location",
			type: "plus",
			direction: "right",
		},
		{
			id: 13,
			x: 44,
			y: 78.5,
			alternateX: 73.3,
			alternateY: 58,
			text: {
				en: "Singapore",
				de: "Singapore",
			},
			typeItemId: 15,
			relatedType: "location",
			type: "plus",
			direction: "right",
		},
		{
			id: 14,
			x: 92,
			y: 68.8,
			alternateX: 34.8,
			alternateY: 71.8,
			text: {
				en: "Rio de Janeiro",
				de: "Rio de Janeiro",
			},
			typeItemId: 16,
			relatedType: "location",
			type: "plus",
			direction: "right",
		},
		{
			id: 15,
			x: 78,
			y: 20,
			alternateX: 59.5,
			alternateY: 45.2,
			text: {
				en: "Dubai",
				de: "Dubai",
			},
			typeItemId: 17,
			relatedType: "location",
			type: "plus",
			direction: "left",
		},
		{
			id: 16,
			x: 46,
			y: 32.5,
			text: {
				en: "",
				de: "",
			},
			count: 3,
			typeItemId: 1002,
			groupFilterIds: [2, 3, 10],
			relatedType: "continent",
			type: "group",
			direction: "right",
		},
		{
			id: 17,
			x: 46.5,
			y: 25.5,
			text: {
				en: "",
				de: "",
			},
			count: 3,
			typeItemId: 1002,
			groupFilterIds: [4, 5, 6],
			relatedType: "continent",
			type: "group",
			direction: "right",
		},
	],
	navigation: [
		{
			key: "",
			title: {
				en: "",
				de: "",
			},
			panelItems: [],
		},
	],
};
